import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import List from './components/List'
import i18n from '@/configs/i18n'
import { TourProvider } from '@/components/TourProvider'
import Create from './components/Create'
import createTour from './components/Create/Tour'
import Update from './components/Update'
const ResumeModule: RouteObject = {
    path: 'resume',
    children: [
        {
            path: '',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: (
                        <TourProvider steps={createTour(i18n.t)}>
                            <Create />
                        </TourProvider>
                    ),
                },
                {
                    path: ':cvID',
                    element: <Update />,
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ResumeModule
